// auth
export const POST_LOGIN = "/login"

// user
export const GET_USERS = "/users"
export const GET_USER_BY_EMAIL = "/users/email"
export const POST_USER = "/users"
export const PUT_USER = "/users"
export const PUT_USER_EDIT_PASSWORD = "/users/edit-password"
export const PUT_USER_RESET_PASSWORD = "/users/reset-password"
export const DELETE_USER = "/users"

// tracking
export const GET_TRACKINGS = "/trackings"
export const GET_TRACKING = "/trackings"
export const GET_TRACKING_WITH_BOOKING_AND_CONTAINER = "/trackings/booking_and_container"
export const SEARCH_TRACKINGS = "/trackings/search"
export const POST_TRACKING = "/trackings"
export const PUT_TRACKING = "/trackings"
export const DELETE_TRACKING = "/trackings"

// tracking image
export const POST_TRACKING_IMAGE = "/trackings/images"
export const DELETE_TRACKING_IMAGE = "/trackings/images"


// container
export const GET_CONTAINERS = "/containers"